<div class="content">
  <div class="price-item" *ngFor="let option of licensePriceOptions; trackBy: trackByFn">
    <span class="price-label">{{ option.label | translate }}</span>
    <span class="price-value">{{ getFormattedPrice(option.price_tier) | async }}</span>
  </div>
</div>
